<template>
	<div v-if="isVisible">
		<div class="d21-modal-background" @click="onOutsideClick"></div>
		<div class="d21-modal-container">
			<div class="d21-modal-header">
				<div class="d21-modal-header-flex">
					<h3 class="d21-modal-header__title">{{ title }}</h3>
					<h3 v-if="titleInfo" class="d21-modal-header__title title-info">{{ titleInfo }}</h3>
				</div>
				<h4 class="d21-modal-header__subtitle">{{ subtitle }}</h4>
			</div>
			<div class="d21-modal-content">
				<slot></slot>
			</div>
			<div class="d21-modal-actions">
				<div class="d21-modal-actions__button" v-for="(action, index) of actions" :key="index">
					<Button :isPrimary="action.isPrimary" :isLoading="loadingButtons.includes(action.loadingEvent)" :isDisabled="action.isDisabled" :text="action.text" :mobileText="action.mobileText" @click="action.onClick" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Button from './ui/button.vue';
	import defaultMixin from "../mixins/default";

	import {
		EventBus
	} from "../scripts/_eventBus.js";

	export default {
		name: "d21-modal",
		mixins: [defaultMixin],
		components: {
			Button
		},
		props: {
			title: {
				type: String,
				required: true
			},
			actions: {
				type: Array,
				required: true
			},
			name: {
				type: String,
				required: true
			},
			titleInfo: {
				type: String,
				default: ""
			},
			subtitle: {
				type: String,
				default: ""
			},
			persistent: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				loadingButtons: [],
				isVisible: false
			}
		},
		created() {
			EventBus.$on(`show:${this.name}`, (status) => {
				this.isVisible = status;
			});
			for (const action of this.actions) {
				if (action.loadingEvent) {
					EventBus.$on(action.loadingEvent, (status) => {
						if (status) this.loadingButtons.push(action.loadingEvent);
						else this.loadingButtons = this.loadingButtons.filter(e => e !== action.loadingEvent);
					})
				}
			}
		},
		methods: {
			onOutsideClick() {
				if (this.persistent) return;
				this.$modals.hide(this.name);
				this.$emit("hide");
			}
		},
		watch: {
			isVisible(newValue) {
				const body = document.getElementsByTagName("body")[0];
				body.style.height = newValue ? '100%' : 'fit-content';
			}
		},
	}
</script>